<template>
  <div>
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#build" @click="activeTab = 'buildsTab'"><i class="fa fa-hammer"></i> Builds</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#domains" @click="activeTab = 'domainsTab'"><i class="fa fa-chart-line"></i> Domains</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row">
            <component :is="activeTab" :orders="orders"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BuildsList from './BuildsList'
import DomainList from './DomainsList'

export default {
  data () {
    return {
      activeTab: 'buildsTab'
    }
  },
  mounted () {
    this.$store.dispatch('loadBuildOrders')
  },
  components: {
    buildsTab: BuildsList,
    domainsTab: DomainList
  },
  computed: {
    ...mapGetters({
      orders: 'getOrders'
    })
  },
  methods: {
    getBuildBreakdown (data) {
      if (!data.built) {
        return {
          built: 0,
          progress: 0,
          waiting: 0,
          missing: 0
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Orders/List.vue